import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  Archive03Icon,
  ArrowRight01Icon,
  HelpCircleIcon,
  Logout03Icon,
  PieChartIcon,
  Settings01Icon,
} from '@hugeicons/core-free-icons';
import { useRouter } from 'next/router';
import { AppDispatch } from '@/store/index';
import { logoutUser } from '@/store/asyncActions/auth';
import { useDispatch } from 'react-redux';
import { dynamicRouteUsage } from '@/components/Sidebar/Tabs';
import useProfileInfo from '@/hooks/useProfileInfo';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
} from '@heroui/react';
import Button from 'ui/button';
import Avatar from 'ui/avatar';

const index = ({ isLarge }: { isLarge?: boolean }) => {
  const router = useRouter();
  const dispatch = useDispatch<AppDispatch>();
  const { username, profilePicUrl, email } = useProfileInfo();

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <div className="w-full p-0">
      <Dropdown placement="right" classNames={{ content: 'shadow-small' }}>
        <DropdownTrigger>
          {isLarge ? (
            <Button
              fullWidth
              className="h-[40px] my-2 justify-start gap-3 bg-transparent px-3 py-[10px]"
              endContent={
                <HugeiconsIcon
                  icon={ArrowRight01Icon}
                  size={32}
                  color="#4a4a4a"
                  strokeWidth={1.5}
                  className="group-hover:bg-background-color rounded-md p-1"
                />
              }
            >
              <div className="flex w-full items-center gap-3">
                <Avatar size="sm" src={profilePicUrl} radius="none" />
                <div className="flex flex-col text-left">
                  <p className="text-small text-foreground leading-5 font-semibold">
                    {username}
                  </p>
                  <p className="text-tiny text-default-text-color">
                    {email && email.length > 20
                      ? email.substring(0, 20) + '...'
                      : email}
                  </p>
                </div>
              </div>
            </Button>
          ) : (
            <div className="flex justify-center items-center cursor-pointer mb-2">
              <Avatar size="md" src={profilePicUrl} radius="none" />
            </div>
          )}
        </DropdownTrigger>
        <DropdownMenu
          aria-label="Profile Actions"
          className="w-[200px] py-1"
          variant="flat"
        >
          <DropdownItem
            key="profile"
            className="h-12 hover:bg-transparent cursor-default"
            showDivider
          >
            <div className="flex w-full items-center gap-3">
              <Avatar size="sm" src={profilePicUrl} radius="none" />
              <div className="flex flex-col text-left">
                <p className="text-small text-primary-text-color leading-5 font-normal">
                  {username}
                </p>
                <p className="text-tiny text-default-text-color">
                  {email && email.length > 20
                    ? email.substring(0, 20) + '...'
                    : email}
                </p>
              </div>
            </div>
          </DropdownItem>

          <DropdownSection aria-label="profile-section-3" className="mb-0">
            <DropdownItem
              key="settings"
              data-item-type="default"
              className="custom-dropdown-item py-2"
              onClick={() => router.push('/settings?tabId=settings')}
            >
              <div className="flex items-center gap-2">
                <HugeiconsIcon
                  icon={Settings01Icon}
                  size={16}
                  color="currentColor"
                  strokeWidth={1.5}
                />
                <span>Settings</span>
              </div>
            </DropdownItem>
            <DropdownItem
              key="archive"
              data-item-type="default"
              className="custom-dropdown-item py-2"
              onClick={() => router.push('/settings?tabId=archive')}
            >
              <div className="flex items-center gap-2">
                <HugeiconsIcon
                  icon={Archive03Icon}
                  size={16}
                  color="currentColor"
                  strokeWidth={1.5}
                />
                <span>Archive</span>
              </div>
            </DropdownItem>
            <DropdownItem
              key="usage"
              data-item-type="default"
              className="custom-dropdown-item py-2"
              onClick={() => router.push(dynamicRouteUsage('my-usage'))}
            >
              <div className="flex items-center gap-2">
                <HugeiconsIcon
                  icon={PieChartIcon}
                  size={16}
                  color="currentColor"
                  strokeWidth={1.5}
                />
                <span>Usage</span>
              </div>
            </DropdownItem>
            <DropdownItem
              key="help"
              data-item-type="default"
              className="custom-dropdown-item py-2"
              onClick={() =>
                window.open('https://docs.enumerate.ai/', '_blank')
              }
              showDivider
            >
              <div className="flex items-center gap-2">
                <HugeiconsIcon
                  icon={HelpCircleIcon}
                  size={16}
                  color="currentColor"
                  strokeWidth={1.5}
                />
                <span>Resource Guide</span>
              </div>
            </DropdownItem>
          </DropdownSection>
          <DropdownSection aria-label="profile-section-3" className="mb-0">
            <DropdownItem
              key="logout"
              data-item-type="default"
              className="custom-dropdown-item py-2"
              onClick={() => handleLogout()}
            >
              <div className="flex items-center gap-2">
                <HugeiconsIcon
                  icon={Logout03Icon}
                  size={16}
                  color="currentColor"
                  strokeWidth={1.5}
                />
                <span>Log Out</span>
              </div>
            </DropdownItem>
          </DropdownSection>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default index;
